"use client";

import React from "react";

//Types
import { ModalDialogProps } from "@/types";

//styles
import * as S from "./styles";

const Dialog: React.FC<ModalDialogProps> = ({
  className,
  childrenBody,
  childrenFooter,
  titleModal,
  onClose,
  open,
}) => {
  if (!open) return null; // Não renderiza o modal se não estiver aberto

  return (
    <S.Modal>
      <S.ModalContent>
        <S.ModalHeader>
          <S.ModalTitle>{titleModal}</S.ModalTitle>
          <S.ModalBtnClose onClick={onClose}>Close</S.ModalBtnClose>
        </S.ModalHeader>
        <S.ModalBody>{childrenBody}</S.ModalBody>
        <S.ModalFooter>{childrenFooter}</S.ModalFooter>
      </S.ModalContent>
    </S.Modal>
  );
};

export default Dialog;
